import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { formatPrice } from 'src/helpers/formatPrice'
import { useGetPropertyChangesQuery } from 'src/redux/api'
import { formatDate } from 'src/helpers/dateHelpers'

// Own-listing change history (roadmap 41 C3): shown inside the owner panel so
// the owner sees how the listing's price moved over time. Self-hides when empty.
const ChangeHistory: FC<{ propertyId: string }> = ({ propertyId }) => {
  const { t } = useTranslation()
  const { data } = useGetPropertyChangesQuery(propertyId)
  const items = data?.items ?? []
  if (!items.length) return null

  return (
    <section className="flex flex-col gap-2 p-4 bg-surface rounded-2xl shadow-card">
      <h3 className="m-0 text-sm font-extrabold leading-5 text-ink">{t('change_history.title')}</h3>
      <ul className="flex flex-col gap-1 m-0 p-0 list-none">
        {items.map((change) => (
          <li key={change.id} className="flex items-center justify-between gap-2 text-sm flex-wrap">
            <span className="text-ink flex items-center gap-1.5 flex-wrap">
              {change.kind === 'PRICE' &&
              change.oldValue != null &&
              change.newValue != null &&
              change.currency ? (
                <>
                  <span>{t('change_history.price')}</span>
                  <span className="line-through text-ink-2">
                    {formatPrice(change.oldValue, change.currency)}
                  </span>
                  <span className="font-black text-ink">
                    → {formatPrice(change.newValue, change.currency)}
                  </span>
                </>
              ) : (
                change.kind
              )}
            </span>
            <span className="text-xs text-ink-2">{formatDate(change.createdAt)}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default ChangeHistory
